export const GU = 8
export const RADIUS = 4
export const MEDIUM_RADIUS = 12
export const BIG_RADIUS = 16
